import type { Dispatch } from 'react';

import { persistBilateralPreference } from './state/bilateralPreference';
import type { DraftEntry, LoggerAction } from './state/loggerDraftTypes';

// The UNI/BI chip's handler, lifted out of useTimelineLogger (LG-28 pushed that
// file over the 500-line cap; prompt.md requires the split in the same change).
//
// It was never focus/binding logic — the one concern that hook actually owns —
// so it is the honest thing to move rather than shaving a comment: it dispatches
// one entry-level field and writes a per-exercise preference to storage, and
// needs nothing from the cursor state machine. Behaviour is unchanged.
export function makeToggleLoadedSides(args: {
  entry: DraftEntry | null;
  entryIdx: number;
  dispatch: Dispatch<LoggerAction>;
}): (next: 1 | 2) => void {
  const { entry, entryIdx, dispatch } = args;
  return (next: 1 | 2) => {
    if (!entry || entryIdx < 0) return;
    dispatch({
      type: 'set_entry_loaded_sides',
      entryIdx,
      loadedSides: next,
    });
    void persistBilateralPreference(entry.exerciseId, next);
  };
}
